import React from 'react'
import './ScrimbaPage.css'
import ScrimbaTransition from '../Components/ScrimbaTransition/ScrimbaTransition'

const ScrimbaPage = () => {
  return (
    <div>
        <ScrimbaTransition />
    </div>
  )
}

export default ScrimbaPage